import { getProvider, Provider } from "@malloc-protocol/anchor";
import { parseTokenAccount, parseMintAccount } from "@project-serum/common";
import {
  AccountInfo,
  ASSOCIATED_TOKEN_PROGRAM_ID,
  MintInfo,
  TOKEN_PROGRAM_ID,
  u64,
} from "@solana/spl-token";
import {
  TokenListProvider,
  TokenInfo,
  TokenListContainer,
  Strategy,
} from "@solana/spl-token-registry";
import { PublicKey } from "@solana/web3.js";
import { solanaConstantsStore } from "../state/flowchart-store";
import { getConstants } from "../config/constants";

export const usedMints = [
  "So11111111111111111111111111111111111111112",
  "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
  "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk",
  "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
  "BQcdHdAQW1hczDbBi9hiegXAR7A98Q9jx3X3iBBBDiq4",
  "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
  "BXXkv6z8ykpG1yuvUDPgh732wzVHB69RnB9YgSYh3itW",
  "3JSf5tPeuscJGtaCp5giEiDhv51gQ4v3zWg8DGgyLfAB",
  "CWE8jPTUYhdCTZYWPTe1o5DFqfdjzWKc9WKz6rSjQUdG",
  "Ga2AXHpfAF6mv2ekZwcsJFqu7wB4NV331qNH7fW9Nst8",
  "AR1Mtgh7zAtxuxGd2XPovXPVjcSdY3i4rQYisNadjfKy",
  "CsZ5LZkDS7h9TDKjrbL7VAwQZ9nsRu8vJLhRYfmGaN8K",
  "SF3oTvfWzEP3DTwGSvUXRrGTvr75pdZNnBLAH9bzMuX",
  "BtZQfWqDGbk9Wf2rXEiWyQBdBY1etnUUn6zEphvVS7yN",
  "5Fu5UUgbjpUvdBveb3a1JTNirL8rXtiYeSMWvKjtUNQv",
  "DEhAasscXF4kEGxFgJ3bq4PpVGp5wyUxMRvn6TzGVHaw",
  "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
  "AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3",
  "MSRMcoVyrFxnSgo5uXwone5SKcGhT1KEJMFEkMEWf9L",
  "GXMvfY2jpQctDqZ9RoU3oWPhufKiCcFEfchvYumtX7jd",
  "EcqExpGNFBve2i1cMJUTR4bPXj4ZoqmDD2rTkeCcaTFX",
  "EqWCKXfs3x47uVosDpTRgFniThL9Y8iCztJaapxbEaVX",
  "GeDS162t9yGJuLEHPWXXGrb1zwkzinCgRwnT8vHYjKza",
  "GUohe4DJUA5FKPWo3joiPgsB7yzer7LpDmt1Vhzy3Zht",
  "9F9fNTT6qwjsu4X4yWYKZpsbw5qT7o6yR2i57JF2jagy",
  "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
  "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
  "MAPS41MDahZ9QdKXhVa4dWB9RuyfV4XqhyAZ8XcYepb",
  "z3dn17yLaGMKffVogeFHQ9zWVcXgqgf3PQnDsNs2g6M",
  "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
  "3K6rftdAaQYMPunrtNRHgnK2UAtjm2JwyT2oCiTDouYE",
  "8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh",
  "StepAscQoEioFxxWGnh2sLBDFp9d8rvKz2Yp39iDpyT",
  "ETAtLmCmsoiEEKfNrHKJ2kYy3MoABhU6NQvpSfij5tDs",
  "8PMHT4swUMtBzgHnh5U564N5sjPSiUz2cjEQzFnnP1Fo",
  "MERt85fc5boKw3BW1eYdxonEuJNvXbiMbs6hvheau5K",
  "TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs",
  "4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y",
  "SLRSSpSLUTP7okbCUBYStWCo1vUgyt775faPqz8HUMr",
  "E5rk3nmgLUuKUiS94gg4bpWwWwyjCMtddsAXkTFLtHEy",
  "BLwTnYKqf7u4qjgZrrsKeNs2EzWkMLqVCu6j8iHyrNA3",
  "7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU",
  "CDJWUqTcYTVAKXAVXoQZFes5JUFc7owSeq7eMQcDSbo5",
  "ArUkYE2XDKzqy77PRRGjo4wREWwqk6RXTfM9NeqzPvjU",
  "3bRTivrVsitbmCTGtqwp7hxXPsybkjn4XLNtPsHqa3zR",
  "GsNzxJfFn6zQdJGeYsupJWzUAm57Ba7335mfhWvFiE9Z",
  "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
  "Ea5SjE2Y6yvCeW5dYTn7PYMuW5ikXkvbGdcmSnXeaLjS",
  "PoRTjZMPXb9T7dyU7tpLEZRQj7e6ssfAE62j2oQuc6y",
  "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
  "DubwWZNWiNGMMeeQHPnMATNj77YZPZSAz2WVR5WjLJqz",
  "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
  "poLisWXnNRwC6oBu1vHiuKQzFjGL4XDSu4g9qjz9qVk",
  "8upjSpvjcdpuzhfR1zriwg5NXkwDruejqNE9WNbPRtyA",
  "3FoUAsGDbvTD6YZ4wVKJgTB76onJUKz7GPEBNiR5b8wc",
  "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
  "Lrxqnh6ZHKbGy3dcrCED43nsoLkM1LTzU2jRfWe8qUC",
  "E5ndSkaB17Dm7CsD22dvcjfrYSDLCxFcMd6z8ddCk5wp",
  "51tMb3zBKDiQhNwGqpgwbavaGH54mk8fXFzxTc1xnasg",
  "MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey",
  "4wjPQJ6PrkC4dHhYghwJzGBVP78DkBzA2U3kHoFNBuhj",
  "5tN42n9vMi6ubp67Uy4NnmM5DMZYN8aS8GeB3bEDHr6E",
  "HZRCwxP2Vq9PCpPXooayhJ2bxTpo5xfpQrwB1svh332p",
  "xxxxa1sKNGwFtw2kFn8XauW9xq8hBZ5kVtcSesTT9fW",
  "PRT88RkA4Kg5z7pKnezeNH4mafTvtQdfFgpQTGRjz44",
  "Saber2gLauYim4Mvftnrasomsv6NvAuncvMEZwcLpD1",
  "EdAhkbj5nF9sRM7XN7ewuW8C9XEUMs8P7cnoQ57SYE96",
  "a11bdAAuV8iB2fu7X6AxAvDTo1QZ8FXB3kk5eecdasp",
  "iVNcrNE9BRZBC9Aqf753iZiZfbszeAVUoikgT9yvr2a",
  "BRLsMczKuaR5w9vSubF4j8HwEGGprVAyyVgS4EX7DKEg",
  "ErGB9xa24Szxbk1M28u2Tx8rKPqzL6BroNkkzk5rG4zj",
  "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
  "FnKE9n6aGjQoNWRBZXy4RW6LZVao7qwBonUbiD7edUmZ",
  "9nEqaUcb16sQ3Tn1psbkWqyhPdLmfHWjKGymREjsAgTE",
  "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
  "SLNDpmoWTVADgEdndyvWzroNL7zSi1dF9PC3xHGtPwp",
  "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
  "8FU95xFJhUUkyyCLU13HSzDLs7oC4QZdXQHL6SCeab36",
  "ChVzxWRmrTeSgwd3Ui3UumcN8KX7VK3WaD4KGeSKpypj",
  "GFX1ZjR2P15tmrSwow6FjyDYcEkoFb4p4gJCpLBjaxHD",
  "inL8PMVd6iiW3RCBJnr5AsrRN6nqr4BTrcNuQWQSkvY",
  "4Hx6Bj56eGyw8EJrrheM6LBQAvVYRikYCWsALeTrwyRU",
  "HCgybxq5Upy8Mccihrp7EsmwwFqYZtrHrsmsKwtGXLgW",
  "HysWcbHiYY9888pHbaqhwLYZQeZrcQMXKQWRqS7zcPK5",
  "CiKu4eHsVrc1eueVQeHn7qhXTcVu95gSQmBpX4utjL9z",
];

export const getAllMints = async (): Promise<TokenInfo[]> => {
  const getCached = async () => {
    if (solanaConstantsStore.state.tokenList)
      return solanaConstantsStore.state.tokenList;
    const tokens = await new TokenListProvider().resolve(Strategy.Solana);
    const tokenList = tokens
      .filterByClusterSlug(getConstants().solana.NETWORK)
      .getList();
    solanaConstantsStore.setState({
      ...solanaConstantsStore.state,
      tokenList,
    });
    return tokenList;
  };
  const tokenList = await getCached();
  return tokenList;
};

export const getMint = async (
  mint: string | PublicKey
): Promise<TokenInfo | undefined> => {
  const infos = await getAllMints();
  return infos.find((tok) => tok.address === mint.toString());
};

// // TODO: have a store for token metadata which has a list of all tokens as well as their metadata

// // See https://github.com/solana-labs/token-list
// export const getTokenLists = async (
//   provider: Provider
// ): Promise<TokenInfo[]> => {
// const getCached = async () => {
//   if (solanaSplStore.state.tokenList) return solanaSplStore.state.tokenList;
//   const tokens = await new TokenListProvider().resolve();
//   const tokenList = tokens
//     .filterByClusterSlug(getConstants().solana.NETWORK)
//     .getList();
//   solanaSplStore.setState({
//     ...solanaSplStore.state,
//     tokenList,
//   });
//   return tokenList;
// };
// const tokenList = await getCached();

// // Add in demo tokens
// return tokenList;
// };

// export const getTokenListContainer = async (
//   provider: Provider
// ): Promise<TokenListContainer> =>
//   new TokenListContainer(await getTokenLists(provider));

// // See https://spl.solana.com/associated-token-account
// export const findAssociatedTokenAddress = async (
//   walletAddress: PublicKey,
//   tokenMintAddress: PublicKey | string
// ): Promise<PublicKey> => {
//   const associated = await PublicKey.findProgramAddress(
//     [
//       walletAddress.toBuffer(),
//       TOKEN_PROGRAM_ID.toBuffer(),
//       new PublicKey(tokenMintAddress).toBuffer(),
//     ],
//     SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID
//   );
//   return associated[0];
// };
// export const findAllAssociatedTokenAddress = async (
//   walletAddress: PublicKey,
//   mints: (PublicKey | string)[]
// ): Promise<PublicKey[]> =>
//   Promise.all(mints.map((m) => findAssociatedTokenAddress(walletAddress, m)));

// export const getTokenAccountInfo = async (
//   provider: Provider,
//   tokenAddr: PublicKey
// ): Promise<AccountInfo | null> => {
//   let account;
//   try {
//     account = await provider.connection.getAccountInfo(tokenAddr);
//   } catch {
//     return null;
//   }
//   if (!account) return null;
//   try {
//     const data = parseTokenAccount(account.data);
//     return data;
//   } catch (e) {
//     console.error("An error occured parsing the data, returning null", e);
//     return null;
//   }
// };

// export const getMintInfo = async (
//   provider: Provider,
//   mintAddr: PublicKey
// ): Promise<MintInfo | null> => {
//   const account = await provider.connection.getAccountInfo(mintAddr);
//   if (!account) return null;
//   return parseMintAccount(account.data);
// };
